import React, {useEffect, useState} from 'react';
import {CloseButton, Input, Modal} from '@mantine/core';
import {useDisclosure} from "@mantine/hooks";
import {denominations} from "../scripts/denominations";
import {Church} from "@mui/icons-material";
import {IconBuildingChurch, IconSearch} from "@tabler/icons-react";
import DenominationDetailsModal from "../widgets/DenominationDetailsModal";
import EmptyState from "../widgets/EmptyState";

const Madhehebu = () => {

    const [opened, { open, close }] = useDisclosure(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [list, setList] = useState(denominations);
    const [searchQuery, setSearchQuery] = useState('');

    const getRandomColor = () => {
        var index = Math.floor(Math.random() * 4);
        return [
            "#88b4f1",
            "#40ebb1",
            "#f8d87b",
            "#ffa9db"
        ][index];
    }

    function filterDenominations(query) {
        const lowerQuery = query.toLowerCase();
        return denominations.filter(denomination =>
            (denomination.name.toLowerCase().includes(lowerQuery)) ||
            (denomination.address.toLowerCase().includes(lowerQuery) ||
                denomination.bishop.toLowerCase().includes(lowerQuery))
        );
    }

    useEffect(() => {
        const filtered = filterDenominations(searchQuery);
        setList(filtered);
    }, [searchQuery]);



    return (
        <div className="flex  flex-col  font-display  text-black dark:text-white">

            {selectedUser && <DenominationDetailsModal denomination={selectedUser} opened={opened} close={close} />}

            <main className="">
                <div className="container  px-4 sm:px-6 lg:px-8 py-12">
                    <div className="z-40 bg-[#f9fafb]/95 dark:bg-[#101922]/95 backdrop-blur-md py-4 mb-8 border-b border-gray-200 dark:border-gray-800" style={{ position: 'sticky', top: '70px' }}>
                        <div className="flex flex-col sm:flex-row justify-between items-center px-2">
                            <h1 className="text-4xl sm:text-5xl font-bold mb-4 sm:mb-0 tracking-tight text-black dark:text-white" data-aos="fade-up">Madhehebu</h1>
                            <div className="w-full sm:w-1/3">
                                <Input value={searchQuery} placeholder={'Tafuta dhehebu, Askofu au Mahali...'} onChange={(e) => setSearchQuery(e.target.value)} leftSection={<IconSearch/>} rightSection={
                                    <CloseButton
                                        aria-label="Clear input"
                                        onClick={() => setSearchQuery('')}
                                        style={{ display: searchQuery ? undefined : 'none' }}
                                    />
                                } size={'md'} rightSectionPointerEvents={'all'}/>
                            </div>
                        </div>
                    </div>

                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
                        {list.map((denomination, index) => (
                            <div
                                key={denomination.id}
                                className="group w-50 cursor-pointer flex flex-col items-center text-center p-6 rounded-lg bg-white dark:bg-black/20 hover:bg-white dark:hover:bg-black/30 shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
                                onClick={() => {
                                    setSelectedUser(denomination);
                                    open();
                                }}
                            >
                                {denomination.image ? <img src={denomination.image} alt={''} className={'h-20 w-20  mb-4'}/> : <IconBuildingChurch className={'mb-3'} size={90} color={"#d3dce6"}/>}
                                <h2 className="text-base text-black dark:text-white leading-tight">
                                    {denomination.name}
                                </h2>
                            </div>
                        ))}

                        {
                            list.length === 0 &&
                            <div className={'bg-white flex justify-center'}><EmptyState title={''} description={'Hakuna dhehebu iliyopatikana'}/></div>
                        }
                    </div>
                </div>
            </main>
        </div>
    );
};

export default Madhehebu;